import PropTypes from 'prop-types';
import { FormattedMessage } from 'dibs-react-intl';

// components
import CheckoutTextWithTooltip from './CheckoutTextWithTooltip';

const CheckoutShippingPromoTooltip = ({ text }) => (
    <CheckoutTextWithTooltip
        text={text}
        tooltip={
            <FormattedMessage
                id="checkout.CheckoutShippingPromoTooltip.shippingTooltip"
                defaultMessage="Don't worry! Your promotion will be applied once your shipping quote has been determined."
            />
        }
        addQuestionMark
    />
);

CheckoutShippingPromoTooltip.propTypes = {
    text: PropTypes.any.isRequired,
};

export default CheckoutShippingPromoTooltip;
